import {Field} from 'formik'
import {Table} from 'src/feature/bite/component'
import {useGetCampaignProductsAll} from '../../context/useQuery'
import {useVIP} from '../../hook'
import {useIntl} from 'react-intl'

type Props = {
  setSection: any
  handleBack: any
  allProducts: any
  paging: any
  pagingSet: any
  selectedProducts: any
  setSelectedProducts: any
}

const SelectGiftProducts = (props: Props) => {
  const intl = useIntl()
  const {selectedGiveAwayProduct, selectedGiveAwayProductSet} = useVIP()

  const {isLoading} = useGetCampaignProductsAll({filterList: []})

  const Columns = [
    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      render: (id: any, record: any) => {
        return (
          <div className='d-flex align-items-center gap-2'>
            <Field
              type='checkbox'
              name='products'
              // checked={values?.products?.includes(id)}
              checked={props.selectedProducts.includes(id)}
              value={id}
              className='form-check-input'
              onChange={(e: any) => {
                if (e.target.checked) {
                  props.setSelectedProducts([...props.selectedProducts, id])
                  selectedGiveAwayProductSet([...selectedGiveAwayProduct, record])
                } else {
                  props.setSelectedProducts(
                    props.selectedProducts.filter((item: any) => item !== id)
                  )
                  selectedGiveAwayProductSet(
                    selectedGiveAwayProduct.filter((item: any) => item.id !== id)
                  )
                }
              }}
            />
          </div>
        )
      },
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.CODE'}),
      key: 'code',
      dataIndex: 'code',
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.NAME'}),
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.CATEGORY'}),
      key: 'category',
      dataIndex: 'category',
    },
  ]

  return (
    <>
      {/* <div className='p-5 d-flex justify-content-between'>
        <button
          className='btn btn-primary'
          onClick={() => {
            props.handleBack()
            props.setSection(1)
          }}
        >
          <span className='d-flex align-items-center gap-2'>
            <i className='bi bi-arrow-left'></i>
            <span>{intl.formatMessage({id: 'GLOBAL.BACK'})}</span>
          </span>
        </button>
      </div> */}
      <div className='p-5'>
        <Table
          loading={isLoading}
          dataSource={props.allProducts}
          columns={Columns}
          pagination={{
            current: props.paging.currentPageNumber,
            pageSize: props.paging.pageSize,
            total: props.paging.totalCount,
            onChange: (page: any) => {
              if (!props || !props.allProducts) return

              const {pageSize, current} = page
              const currentPage = pageSize !== props.paging.pageSize ? 1 : current

              props.pagingSet({
                ...props.paging,
                currentPageNumber: currentPage,
                pageSize: pageSize,
              })
            },
          }}
        />
      </div>
      <div className='p-5 d-flex justify-content-end'>
        <button
          className='btn btn-primary'
          onClick={() => {
            props.handleBack()
            props.setSection(1)
          }}
        >
          <span className='d-flex align-items-center gap-2'>
            {/* <i className='bi bi-arrow-left'></i> */}
            <span>{intl.formatMessage({id: 'GLOBAL.ADD'})}</span>
          </span>
        </button>
      </div>
    </>
  )
}

export default SelectGiftProducts
